export interface StudentSkill {
  skill: Skill;
  usersBySkillResults: UsersBySkillResult[];
}

export interface Skill {
  id: string;
  name: string;
  code: string;
}

export interface UsersBySkillResult {
  value: Value[];
  key: string;
}

export interface Value {
  id: string;
  firstName: string;
  lastName: string;
}

export interface DiagnosticSkillHistoryTableItem {
  skill: SkillItem | null;
  placedOut: PlacedOut[];
}

interface PlacedOut {
  id: string;
  firstName: string;
  lastName: string;
  publicUserId: string;
}

interface SkillItem {
  id: string;
  code: string | null;
  name: string | null;
}

export interface DiagnosticAssessmentTableFilters {
  first: number;
  rows: number;
  page?: number;
  pageCount: number;
  sortField: string;
  sortOrder: 1 | -1;
  filters: Filters;
  multiSortMeta: null;
  prevPage: number;
}

interface Filters {
  skillName: string | null;
  classes: string[];
  roadmaps: string[];
  skillGrades: string[] | null;
  gradeLevels: string[] | null;
  [key: string]: string | number | string[] | number[] | (Date | null)[] | { id: string; name: string }[] | null;
}

export const filterStateDiagnosticAssessmentsInitValue: DiagnosticAssessmentTableFilters = {
  first: 0,
  rows: 10,
  page: 0,
  pageCount: 0,
  sortField: 'name',
  sortOrder: 1,
  filters: {
    skillName: null,
    classes: [],
    roadmaps: [],
    skillGrades: null,
    gradeLevels: null,
  },
  multiSortMeta: null,
  prevPage: 0,
};

export interface TemporarySkillInterface {
  id: string;
  code?: string | null;
  name?: string | null;
}
